import { forwardRef, type Ref, type SVGProps } from "react";
const IconBeachOutlineSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path
      fill="currentColor"
      d="M4.7 28.714A3.47 3.47 0 0 1 7 28a3.48 3.48 0 0 1 2.293.707A5.3 5.3 0 0 0 13 30a5.3 5.3 0 0 0 3.7-1.281A3.47 3.47 0 0 1 19 28a3.48 3.48 0 0 1 2.293.707A5.3 5.3 0 0 0 25 30a5.3 5.3 0 0 0 3.708-1.3.99.99 0 0 0 .006-1.4 1.006 1.006 0 0 0-1.408-.03 3.47 3.47 0 0 1-2.3.719 3.48 3.48 0 0 1-2.293-.707A5.3 5.3 0 0 0 19 26a5.3 5.3 0 0 0-3.7 1.281A3.47 3.47 0 0 1 13 28a3.48 3.48 0 0 1-2.293-.707A5.3 5.3 0 0 0 7 26a5.3 5.3 0 0 0-3.707 1.293 1 1 0 0 0-.006 1.4 1.01 1.01 0 0 0 1.413.021M10 21a2.917 2.917 0 0 0-3 2.829V24a.994.994 0 0 0 .987.993H8a1.006 1.006 0 0 0 1-.981A.92.92 0 0 1 9.816 23 1 1 0 0 1 10 23h16a1 1 0 0 0 0-2h-9.98l2.32-8.653 8.4 2.25a1.4 1.4 0 0 0 .35.04 1.114 1.114 0 0 0 1.15-.93c.59-4.64-2.46-9.23-7.33-10.98l.02-.04a1 1 0 0 0-1.94-.52l-.01.06a12 12 0 0 0-2.19-.23 10.36 10.36 0 0 0-9.71 6.04 1.16 1.16 0 0 0 .72 1.475 1 1 0 0 0 .143.04l8.47 2.27L13.952 21ZM9.4 7.872a8.52 8.52 0 0 1 7.39-3.88 10.4 10.4 0 0 1 1.67.16c.32.06.64.11.95.19a8 8 0 0 1 .98.33 8.75 8.75 0 0 1 5.92 7.73l-7.45-2-1.94-.51Z"
    />
  </svg>
);
const ForwardRef = forwardRef(IconBeachOutlineSVG);
ForwardRef.displayName = "IconBeachOutline";
export { ForwardRef as IconBeachOutline };
